// Static phrase-based translations — no API calls
// Each locale file has a flat "translations" map: { "French phrase": "translated phrase" }

// French = source language, no translation needed
const FRENCH_LOCALES = new Set(['ma-fr','tn-fr','dz-fr','fr-fr','world-fr']);

export function needsTranslation(localeKey) {
  return !FRENCH_LOCALES.has(localeKey);
}

// Shared translation files by language
const SHARED_LOCALE_FILE = {
  // Arabic → shared ar.json
  'ma-ar': 'ar', 'tn-ar': 'ar', 'dz-ar': 'ar', 'fr-ar': 'ar', 'world-ar': 'ar',
  // English → shared world-en.json
  'ma-en': 'world-en', 'tn-en': 'world-en', 'dz-en': 'world-en', 'fr-en': 'world-en',
};

// Locale → translation map cache
const _maps = {};

async function getMap(localeKey) {
  if (_maps[localeKey]) return _maps[localeKey];
  const file = SHARED_LOCALE_FILE[localeKey] || localeKey;
  try {
    const mod = await import(`../locales/${file}.json`);
    _maps[localeKey] = mod.translations || {};
  } catch {
    _maps[localeKey] = {};
  }
  return _maps[localeKey];
}

export async function translateText(text, localeKey) {
  if (!needsTranslation(localeKey)) return text;
  if (!text || typeof text !== 'string' || !text.trim()) return text;
  const map = await getMap(localeKey);
  return map[text] || text;
}

function applyMap(val, map) {
  if (typeof val === 'string') return map[val] || val;
  if (Array.isArray(val)) return val.map(v => applyMap(v, map));
  if (val !== null && typeof val === 'object') {
    return Object.fromEntries(Object.entries(val).map(([k, v]) => [k, applyMap(v, map)]));
  }
  return val;
}

export async function translateObject(obj, localeKey) {
  if (!needsTranslation(localeKey)) return obj;
  const map = await getMap(localeKey);
  if (!Object.keys(map).length) return obj;
  return applyMap(obj, map);
}
